export var ActionCrud;
(function (ActionCrud) {
    ActionCrud["EDIT"] = "edit";
    ActionCrud["ADD"] = "add";
})(ActionCrud || (ActionCrud = {}));
